let global;
let environment = 'productions'
// 备注: local : 本地运行163  pathApi 为 http://192.168.10.163, 如改为252 需要把pathApi 为 http://192.168.10.252
//       163 : 本地打包163
//       252 : 本地打包252
//       localSC  :  本地运行生产环境
//       localuat :  本地运行Uat环境  
// 注:  此文件提交代码时不要提交
let pathApi = 'http://192.168.10.163'
let path = 'http://localhost'
let cookiePath = 'localhost'
let appidSC = 'wxa4dfd6c75fc271eb' //正式环境appid
let appidUat = 'wxaa556816d4b73be4' //正式环境appid

switch(environment){
    case 'local':
        // path = 'http://192.168.10.170'
        // cookiePath = '192.168.10.170'//不能加http
        break;
    case '163':
        path = 'http://192.168.10.163'
        cookiePath = '192.168.10.163'
        break;
    case '99':
        path = 'http://192.168.10.99'
        pathApi = 'http://192.168.11.74'
        cookiePath = '192.168.10.99'
        break;
    case '252':
        path = 'http://192.168.10.252'
        pathApi = 'http://192.168.10.252'
        cookiePath = '192.168.10.252'
        break;
    case '72':
        path = 'http://192.168.11.72'
        pathApi = 'http://192.168.11.72'
        cookiePath = '192.168.11.72'
        break;
    case 'production':
        break;

    default:break;
}
let baseGlobal = {
    cookiePath: cookiePath,
    loginPath:path+':7000',
    srmPath:path+':7030',
    tasPath:path+':7020',
    dasPath:path+':7050',
    // BaseApi: pathApi+':8000',
    BaseApi: pathApi+':7000',
    uploadurl:pathApi+':8211',
    appid:appidSC,
}
if(environment=='production'){
    global = {
        cookiePath:'.zhulvtong.com',
        loginPath:'http://www.zhulvtong.com',
        srmPath:'http://srm.zhulvtong.com',
        tasPath:'http://tas.zhulvtong.com',
        dasPath:'http://das.zhulvtong.com',
        BaseApi: 'http://www.zhulvtong.com', //请求地址
        uploadurl:'http://www.zhulvtong.com',
        appid:appidSC,
    }
}else if(environment=='productions'){
    global = {
        cookiePath:'.zhulvtong.com',
        loginPath:'https://www.zhulvtong.com',
        srmPath:'https://srm.zhulvtong.com',
        tasPath:'https://tas.zhulvtong.com',
        dasPath:'https://das.zhulvtong.com',
        BaseApi: 'https://www.zhulvtong.com', //请求地址
        uploadurl:'https://www.zhulvtong.com',
        appid:appidSC,
    }

}else if(environment=='productions2'){
    global = {
        cookiePath:'.zhulvtong.com',
        loginPath:'https://www.zhulvtong.com',
        srmPath:'http://srm.zhulvtong.com',
        tasPath:'http://tas.zhulvtong.com',
        dasPath:'http://das.zhulvtong.com',
        BaseApi: 'https://www.zhulvtong.com', //请求地址
        uploadurl:'https://www.zhulvtong.com',
        appid:appidSC,
    }
}else if(environment=='uat'){
    // global = {
    //     cookiePath:'.zhulvtong.com',
    //     loginPath:'https://uat.zhulvtong.com',
    //     srmPath:'https://uat-srm.zhulvtong.com',
    //     tasPath:'https://uat-tas.zhulvtong.com',
    //     dasPath:'http://uat-das.zhulvtong.com',
    //     BaseApi: 'https://uat.zhulvtong.com', //请求地址
    //     uploadurl:'https://uat.zhulvtong.com',
    //     appid:appidUat,
    // }
    global = {
        cookiePath:'192.168.10.79',
        loginPath:'http://192.168.10.79:7000',
        srmPath:'http://192.168.10.79:7030',
        tasPath:'http://192.168.10.79:7020',
        dasPath:'http://192.168.10.79:7050',
        BaseApi: 'http://192.168.10.79:7000', //请求地址
        uploadurl:'http://192.168.10.79:8211',
        appid:appidUat,
    }

    
}else if(environment=='localSC'){
    baseGlobal.BaseApi = 'https://www.zhulvtong.com' //请求地址
    baseGlobal.uploadurl = 'https://www.zhulvtong.com'
    global = baseGlobal
}
else if(environment=='localuat'){
    baseGlobal.BaseApi = 'http://192.168.10.79:7020' //请求地址
    baseGlobal.uploadurl = 'http://192.168.10.79:7020'
    baseGlobal.appid = appidUat
    global = baseGlobal
}
else{
   global = baseGlobal
}
global.environment = environment
module.exports = global





//////////////////
// WEBPACK FOOTER
// ./static/global.js
// module id = IJof
// module chunks = 95